import { render, staticRenderFns } from "./BookingContextMenu.vue?vue&type=template&id=ba8b1a0a&scoped=true"
import script from "./BookingContextMenu.vue?vue&type=script&lang=ts"
export * from "./BookingContextMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba8b1a0a",
  null
  
)

export default component.exports